<template>
  <span>
    <slot></slot>
    <vue-programmatic-invisible-google-recaptcha
      ref="invisibleRecaptcha1"
      :sitekey="getEnvCaptcha()"
      :elementId="'invisibleRecaptcha1'"
      :badgePosition="'left'"
      :showBadgeMobile="true"
      :showBadgeDesktop="true"
      @recaptcha-callback="recaptchaCallback"
    >
    </vue-programmatic-invisible-google-recaptcha>
  </span>
</template>

<script>
export default {
  data() {
    return {
      recaptchaToken: null,
    };
  },
  methods: {
    getEnvCaptcha() {
      return process.env.VUE_KEY_CAPTCHA;
    },
    resetCaptcha() {
      try {
        if (this.$refs.invisibleRecaptcha1) {
          this.$refs.invisibleRecaptcha1.reset();
        }
      } catch (e) {
        console.warn('[Captcha] Falha ao resetar reCAPTCHA:', e);
      }
    },
    setCaptcha() {
      try {
        if (this.$refs.invisibleRecaptcha1) {
          this.$refs.invisibleRecaptcha1.execute();
        } else {
          console.warn('[Captcha] Widget indisponível, emitindo fallback');
          this.$emit("changeVerify", null);
        }
      } catch (e) {
        console.warn('[Captcha] Falha ao executar reCAPTCHA:', e);
        this.$emit("changeVerify", null);
      }
    },
    recaptchaCallback(recaptchaToken) {
      this.$emit("changeVerify", recaptchaToken);
    },
  },
};
</script>